import { WorkOrderTableRowSchema } from "@redotech/redo-fulfillment-common/work-order/work-order-table-row";
import * as z from "zod";

export const getWorkOrder = {
  name: "getWorkOrder" as const,
  input: z.object({ workOrderId: z.string() }),
  output: z.object({ workOrder: WorkOrderTableRowSchema.nullable() }),
};
